import { useQuery } from '@tanstack/react-query'

import { StaleTime } from '@core/query'
import { type TAudioSuggestions } from '@core/models'
import { AudioQueryKey } from '../helpers/queryKeys'

import { getAudioSuggestions } from '../services/getAudioSuggestions'

type TUseAudioSuggestionsParams = {
    username: string
    slug: string
    /** Seeded from the SSR loader so the first render matches the server without a refetch. */
    initialData?: TAudioSuggestions
}

export const useAudioSuggestions = ({
    username,
    slug,
    initialData,
}: TUseAudioSuggestionsParams) => {
    return useQuery({
        queryKey: AudioQueryKey.audioSuggestions(username, slug),
        queryFn: ({ signal }) => getAudioSuggestions({ username, slug, signal }),
        initialData,
        enabled: Boolean(username && slug),
        staleTime: StaleTime.Short,
    })
}
